import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button } from "@xfrontend/xui-react-plus";

// Shown when GET /me failed transiently (5xx / network). A transient failure must NOT be
// misrouted to /no-access (permanent contact-IT) nor left as a silent blank page — offer a retry.
const Wrap = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--x-bg-main, #0E0A13);
  padding: 24px;
`;

const Card = styled.div`
  width: min(440px, 100%);
  background: var(--x-bg-500, #2d293a);
  border: 1px solid var(--x-purple-500, #494358);
  border-radius: 12px;
  padding: 32px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 700;
  color: var(--x-gray-200, #f6f6f7);
  margin: 0 0 10px;
`;

const Message = styled.p`
  font-size: 13px;
  color: var(--x-gray-400, #cfd0d3);
  margin: 0 0 22px;
`;

const OrgGateError = ({ onRetry }: { onRetry: () => void }): JSX.Element => {
  const { t } = useTranslation("org");
  return (
    <Wrap>
      <Card>
        <Title>{t("error.title")}</Title>
        <Message>{t("error.message")}</Message>
        <Button variant="primary" onClick={onRetry}>
          {t("error.retry")}
        </Button>
      </Card>
    </Wrap>
  );
};

export default OrgGateError;
